import { render } from "./ModalTip.vue?vue&type=template&id=c0f83310&scoped=true"
import script from "./ModalTip.vue?vue&type=script&lang=js"
export * from "./ModalTip.vue?vue&type=script&lang=js"

import "./ModalTip.vue?vue&type=style&index=0&id=c0f83310&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0f83310"]])

export default __exports__